import { render } from "./SystemAdmin17.vue?vue&type=template&id=527c5e76"
import script from "./SystemAdmin17.vue?vue&type=script&lang=js"
export * from "./SystemAdmin17.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__